// extracted by mini-css-extract-plugin
export var $animation_name = "Breadcrumbs-module--$animation_name--aa296";
export var breadcrumbs = "Breadcrumbs-module--breadcrumbs--87091";